import { RouteObject } from "react-router-dom";

import { checkBooleanScope } from "@src/components/LimitAccess/check-scopes";

import { GENERAL_ROUTES } from "../../routes";

/**
 * The merchant Agentic Logic surface is ONE route: the list, the creation
 * flow, and the rule workspace are views of `/rules` selected by the `rule`
 * query param, so the Atlas rail beside them survives the hand-off from a
 * build to the rule it produced. `/rules/new` and `/rules/:ruleId` remain only
 * as redirects for links minted before the change.
 *
 * The route is unpadded: the page mounts `AgenticLogicPageShell` (breadcrumbs
 * on the background, content in one elevated card), which owns the full frame
 * itself — a padded shell would double the gutters.
 */
export const RulesRoutes: RouteObject[] = [
  {
    path: GENERAL_ROUTES.Rules,
    lazy: async () => {
      const { MerchantRulesRoute } =
        await import("@src/features/ai/pages/agentic-logic/routes/MerchantRules.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");

      return {
        element: (
          <ScopedRoute
            debugId={GENERAL_ROUTES.Rules}
            allowAdminBypass={false}
            isEnabled={({ org }) =>
              checkBooleanScope("agentic_logic_enabled", org.configurations)
            }
            children={MerchantRulesRoute}
          />
        ),
      };
    },
  },
  {
    path: GENERAL_ROUTES.NewRule,
    lazy: async () => {
      const { AgenticLogicNewRuleRedirect } =
        await import("@src/features/ai/pages/agentic-logic/routes/AgenticLogicLegacyRedirect");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      const { MERCHANT_AGENTIC_LOGIC_SURFACE } =
        await import("@src/features/ai/pages/agentic-logic/surface/surface");

      return {
        element: (
          <ScopedRoute
            debugId={GENERAL_ROUTES.NewRule}
            allowAdminBypass={false}
            isEnabled={({ org }) =>
              checkBooleanScope("agentic_logic_enabled", org.configurations)
            }
            children={AgenticLogicNewRuleRedirect}
            componentProps={{ surface: MERCHANT_AGENTIC_LOGIC_SURFACE }}
          />
        ),
      };
    },
  },
  {
    path: GENERAL_ROUTES.Rule,
    lazy: async () => {
      const { AgenticLogicRuleRedirect } =
        await import("@src/features/ai/pages/agentic-logic/routes/AgenticLogicLegacyRedirect");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      const { MERCHANT_AGENTIC_LOGIC_SURFACE } =
        await import("@src/features/ai/pages/agentic-logic/surface/surface");

      return {
        element: (
          <ScopedRoute
            debugId={GENERAL_ROUTES.Rule}
            allowAdminBypass={false}
            isEnabled={({ org }) =>
              checkBooleanScope("agentic_logic_enabled", org.configurations)
            }
            children={AgenticLogicRuleRedirect}
            componentProps={{ surface: MERCHANT_AGENTIC_LOGIC_SURFACE }}
          />
        ),
      };
    },
  },
];
